/* Progressive enhancement: the collection stays server-rendered without JavaScript. */
(() => {
  const init = (scope = document) => {
    scope.querySelectorAll('[data-pl-collection]').forEach((collection) => {
      if (collection.dataset.plCollectionReady) return;
      collection.dataset.plCollectionReady = 'true';
      const form = collection.querySelector('[data-pl-collection-form]');
      const filters = collection.querySelector('[data-pl-collection-filters]');
      const sort = collection.querySelector('[data-pl-collection-sort]');
      sort?.addEventListener('change', () => {
        if (form.reportValidity()) form.requestSubmit();
      });
      const closeFilters = () => {
        if (!filters?.open) return;
        filters.open = false;
        filters.querySelector('summary')?.focus();
      };
      collection.querySelector('[data-pl-close-filters]')?.addEventListener('click', closeFilters);
      collection.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && filters?.open) {
          event.preventDefault();
          closeFilters();
        }
      });
      form?.addEventListener('formdata', (event) => {
        // Empty range inputs should not add meaningless empty price filters.
        form.querySelectorAll('input[type="number"]').forEach((input) => {
          if (input.value === '') event.formData.delete(input.name);
        });
      });
    });
  };
  init();
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
